import Vue from 'vue'
import App from '@/App.vue'
import router from '@/routes/router'
import store from '@/store/store'
import appInfo from '@/utils/appInfo'

Vue.prototype.$staticUrl = appInfo.staticPath+process.env.BASE_URL;

Vue.prototype.$isIe11 = window.navigator.userAgent.indexOf("Trident/7.0") > -1;
Vue.config.productionTip = false;

const preloaderGetImg = ()=>{
  //  if(process.env.NODE_ENV == 'development')return [''];
    let baseURL = process.env.BASE_URL;
    let imgArray = [];
    for (let i=0; i < 199; i++)
    {
        imgArray.push(`${baseURL}img/logo_intro/start_${i}.png`);
    };
    for (let i=0; i < 59; i++)
    {
        imgArray.push(`${baseURL}img/logo_loop/loop_${i}.png`);
    };
    for (let i=1; i <= 6; i++)
    {
        imgArray.push(`${baseURL}img/bg_${i}.jpg`);

        imgArray.push(`${baseURL}img/txt_${i}_stit.png`);

        if(i != 1){
            imgArray.push(`${baseURL}img/txt_${i}_tit.png`);
            imgArray.push(`${baseURL}img/txt_${i}_txt.png`);
        }
        if(i == 5){
            imgArray.push(`${baseURL}img/obj_${i}_1.png`);
            imgArray.push(`${baseURL}img/obj_${i}_2.png`);

        }else if(i == 3){

        }else{
            imgArray.push(`${baseURL}img/obj_${i}.png`);
        }
    };
    return imgArray;
}

const preloaderGetVideo = ()=>{
    if(process.env.NODE_ENV == 'development')return [''];
    let baseURL = process.env.BASE_URL;
    let videoArray = [];

    for (let i=1; i <= 6; i++)
    {
        videoArray.push(`https://vod.plaync.com/lineage/remaster0320/0320_remaster_bg${i}.mp4`);
    };
    return videoArray;
}

new nc.promokit.Preloader({
    'game': 'lineage',
    'delay': 500,
    image: preloaderGetImg(),
    "video": preloaderGetVideo()
});


$(document).on("preloadend", function (){

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
});

